import * as React from "react";

import MenuItem from "@mui/material/MenuItem";
import {updateMarqueEditorialeParameter} from '../../action/parametrageAction'
import {ParamsMarqueCollection} from "../../types";
import Select from "@mui/material/Select";
import { useAppDispatch } from "../../store";


interface Props {
    defaultParams: ParamsMarqueCollection,
    value: string
}

export const NBComplementOperator: React.FC<Props> = ({value, defaultParams}) => {
    const dispatch = useAppDispatch();

    return (
        <Select value={value}
                onChange={(event) => {
                    const newParam = {
                        ...defaultParams,
                        operatorComplement: event.target.value as string
                    }
                    dispatch(updateMarqueEditorialeParameter(newParam))
                }}
        >
            <MenuItem value={"="}>{"="}</MenuItem>
            <MenuItem value={">="}>{">="}</MenuItem>
        </Select>
    )
};
